import axios from "axios";
import { config_multipart } from "../../api-helper/api-header-config";
// const baseURL = process.env.REACT_APP_API_URL;
import secureLocalStorage from "react-secure-storage";
const REACT_APP_CENTRAL_API_URL = process.env.REACT_APP_CENTRAL_API_URL;
// Add User
export const add_user = async (formData:object) => {
    const response = await axios.post(secureLocalStorage.getItem("baseURL") + "/api/user", formData, {
    });
    return response.data;
};
export const add_tenant_user = async (formData:object) => {
    const response = await axios.post(REACT_APP_CENTRAL_API_URL + "/api/add-tenant-user", formData, config_multipart
    );
    return response.data;
};
// Get All Roles
export const get_all_roles = async () => {
  let response = await axios.get(secureLocalStorage.getItem("baseURL") + "/api/roles");
  return response.data;
}
// List Of Users
export const get_all_users = async () => {
  let response = await axios.get(secureLocalStorage.getItem("baseURL") + "/api/filter-user");
  return response.data;
}
// Get Single User
export const get_single_user = async (id) => {
  let response = await axios.get(secureLocalStorage.getItem("baseURL") + "/api/user/"+id);
  return response.data;
}
// List Of Users
export const get_all_users_against_department = async (id: number) => {
  let response = await axios.get(secureLocalStorage.getItem("baseURL") + "/api/all-users-against-department/" + id);
  return response.data;
}
// Get Single User Logs by ID
export const get_user_logs = async (id: number) => {
  let response = await axios.get(secureLocalStorage.getItem("baseURL") + "/api/user-activity-log/" + id);
  return response.data;
};
// Get All Users Logs
export const get_all_users_logs = async () => {
  let response = await axios.get(secureLocalStorage.getItem("baseURL") + "/api/user-activity-logs");
  return response.data;
};
//Active Users
export const get_all_active_users=async () => {
  const response = await axios.get(secureLocalStorage.getItem("baseURL") + '/api/filter-user/'+1);
    return response.data;
};
// Status Filter Users
export const get_all_filters_status_users=async (status) => {
  const response = await axios.get(secureLocalStorage.getItem("baseURL") + '/api/filter-user/'+status);
    return response.data;
};
export const get_tenant_setting = async () => {
  const response = await axios.get(secureLocalStorage.getItem("baseURL") + '/api/get-tenant-setting');
    return response.data.data;
};
export const verify_user = async (email) => {
  let response = await axios.post(REACT_APP_CENTRAL_API_URL + "/api/user-exists", {
    'email': email
  });
  return response.data;
}
// Get Filtered Users
export const get_filtered_users = async (
  fromDateFilter: string,
  toDateFilter: string,
  departmentId: string,
  roleId: string,
  selectedStatus: string,
  updatedBy: string,
  page: number,
  itemsPerPage: number 
) => {
  const baseURL = secureLocalStorage.getItem("baseURL");
  const apiEndpoint = "/api/get-users-by-filter";

  const payload = {
    from_date: fromDateFilter,
    to_date: toDateFilter,
    department_id: departmentId,
    role_id: roleId,
    status: selectedStatus,
    updated_by_user_id: updatedBy,
    page: page,
    per_page: itemsPerPage,
  };

  // Remove empty/null keys from payload to avoid sending them if not set
  Object.keys(payload).forEach(key => {
    if (payload[key] === "" || payload[key] === null || payload[key] === undefined) {
      delete payload[key];
    }
  });
  
  try {
    const response = await axios.post(baseURL + apiEndpoint, payload);
    return response;
  } catch (error) {
    console.error("Error fetching filtered users:", error);
    if (axios.isAxiosError(error)) {
      throw new Error(error.response?.data?.message || error.message || 'Failed to fetch filtered users');
    }
    throw error;
  }
};
// Delete User
export const delete_user = async (id: number) => {
  let response = await axios.delete(secureLocalStorage.getItem("baseURL") + "/api/user/" + id);
  return response.data;
}
// Edit User
export const update_user = async (id:number,formData:object) => {
    const response = await axios.post(secureLocalStorage.getItem("baseURL") + "/api/update-user/" + id, formData,config_multipart)
  return response.data;
}
export const update_tenant_user = async (formData:object) => {
    const response = await axios.post(REACT_APP_CENTRAL_API_URL + "/api/update-tenant-user", formData,config_multipart)
  return response.data;
}
// change status 
export const change_active_status_user = async (id:number) => {
  let response = await axios.post(secureLocalStorage.getItem("baseURL") + "/api/update-status/" + id, {
    model_name:"user",
  });
  return response.data;  
}
export const user_password_reset = async (token, email, password, password_confirmation) => {
  const response = await axios.post(
    `${secureLocalStorage.getItem("baseURL")}/api/reset-password`,
    {
      token: token,
      email: email,
      password: password,
      password_confirmation: password_confirmation
    }
  );
  return response.data;
};